var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-menu-item',{attrs:{"index":"/settings"}},[_c('router-link',{staticClass:"sub-menu-link",attrs:{"to":"/settings"}},[_c('span',{staticClass:"text-underline cursor-pointer"},[_vm._v(_vm._s(_vm.user.first_name + " " + _vm.user.last_name))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }